// src/utils/formQuestions.js

export const questions = [
  {
    id: "height",
    title: "Height (cm)",
    fieldType: "number",
    required: true,
    repeatable: true,
    group: "metadata",
  },
  {
    id: "weight",
    title: "Weight (kg)",
    fieldType: "number",
    required: true,
    repeatable: true,
    group: "metadata",
  },
  {
    id: "chestCircumference",
    title: "Chest Circumference (cm)",
    fieldType: "number",
    required: true,
    repeatable: true,
    group: "metadata",
    resourceUrl:
      "https://firebasestorage.googleapis.com/v0/b/pdx-web-v2.firebasestorage.app/o/metadata_form_assets%2Fchest_measurement.PNG?alt=media&token=8266715a-b1a8-4a64-a723-65b5eda7a092",
    description:
      "Measure your chest circumference at the topmost part of the chest - directly under the underarms and above the bust - keeping the tape level around your torso and snug without compressing the chest.",
  },
  {
    id: "dateOfBirth",
    title: "Date of Birth",
    fieldType: "date",
    required: true,
    repeatable: true,
    group: "metadata",
  },
  {
    id: "sexAtBirth",
    title: "Sex at Birth",
    fieldType: "select",
    required: true,
    options: [
      { value: "Female", label: "Female" },
      { value: "Male", label: "Male" },
    ],
    repeatable: true,
    group: "metadata",
  },
  {
    id: "ethnicity",
    title: "Ethnicity",
    fieldType: "select",
    required: true,
    options: [
      { value: "Caucasian", label: "Caucasian (White)" },
      { value: "Black", label: "Black" },
      { value: "North East Asian", label: "North East Asian" },
      { value: "South East Asian", label: "South East Asian" },
      { value: "Other", label: "Other / Mixed" },
    ],
    repeatable: true,
    group: "metadata",
  },
  {
    id: "respiratoryConditions",
    title: "Which respiratory condition do you have?",
    fieldType: "select",
    required: true,
    options: [
      { value: "none", label: "None" },
      { value: "ild", label: "ILD (Interstitial Lung Disease)" },
      { value: "copd", label: "COPD" },
      { value: "asthma", label: "Asthma" },
      { value: "copd_asthma", label: "COPD and Asthma" },
    ],
    group: "metadata",
  },

  // Smoking Questions
  {
    id: "smoking",
    title: "Smoking Status",
    fieldType: "select",
    required: true,
    options: [
      { value: "never", label: "Never" },
      { value: "former", label: "Former" },
      { value: "current", label: "Current" },
      { value: "ecigarette", label: "E-cigarette user only" },
    ],
    repeatable: true,
    group: "metadata",
  },

  // Ex-smoker follow-up questions:
  {
    id: "yearsSinceQuit",
    title: "How long ago did you quit smoking?",
    fieldType: "select",
    required: true,
    options: [
      { value: "lessThan1month", label: "Less than 1 month" },
      { value: "1-6months", label: "1-6 months" },
      { value: "6-12months", label: "6-12 months" },
      { value: "1-5years", label: "1-5 years" },
      { value: "moreThan5years", label: "More than 5 years" },
    ],
    condition: (data) => data.smoking === "former",
    repeatable: true,
  },
  {
    id: "exQuitEffect",
    title: "Rate how quitting has affected your breathing",
    fieldType: "range",
    required: false,
    min: 0,
    max: 10,
    step: 1,
    description: "0 = No improvement, 10 = Significant improvement",
    condition: (data) => data.smoking === "former",
    repeatable: true,
  },
];
